import "./console.css";
import type { Concept } from "../types";
import { ConsoleShell } from "./Shell";
import { ConsoleEmptyState, ConsolePageHeader } from "./chrome";
import { ConsoleTaskRow } from "./TaskRow";
import { ConsoleTaskList } from "./TaskList";
import { ConsoleTaskDetail } from "./TaskDetail";
import { ConsoleBoard } from "./Board";
import { ConsoleTodayScreen } from "./Today";

/** Console: Linear-leaning, dense, keyboard-first. Dark by default, detail in a right panel. */
export const console: Concept = {
  id: "console",
  name: "Console",
  className: "concept-console",
  defaultAppearance: "dark",
  detailMode: "panel",
  rowHeight: 36,
  Shell: ConsoleShell,
  PageHeader: ConsolePageHeader,
  EmptyState: ConsoleEmptyState,
  TaskRow: ConsoleTaskRow,
  TaskList: ConsoleTaskList,
  TaskDetail: ConsoleTaskDetail,
  Board: ConsoleBoard,
  TodayScreen: ConsoleTodayScreen,
};
